// Profile photo can live under different keys depending on which app wrote the user.
export const avatarUrl = (u) =>
  u?.profileImage || u?.profilePhotoUrl || u?.profilePhoto || u?.photoURL || u?.photoUrl || u?.imageUrl || undefined;
